import { all } from "redux-saga/effects";
import watchFetchCancelService from "./brotherPlus/cancelService/cancelServiceSaga";
import watchRegisterService from "./brotherPlus/EnrollmentService/RegisterService/RegisterServiceSaga";
import watchGetDevicesService from "./brotherPlus/getDevices/getDevicesSaga";
import watchGetDeviceStatusService from "./brotherPlus/getDeviceStatus/getDeviceStatusSaga";
import watchGetPrintHistoryService from "./brotherPlus/getPrintHistory/getPrintHistorySaga";
import watchGetUserPromoCodeService from "./brotherPlus/getUserPromoCode/getUserPromoCodeSaga";
import watchAddUserActivityLogService from "./brotherPlus/AddUserActivityLogService/addUserActivityLogServiceSaga";
import watchFetchUserDeviceStatusService from "./CSAgentPortal/BrotherPlus/GetUserDeviceStatusSaga";
import watchFetchUserSubscriptionDetailsService from "./CSAgentPortal/BrotherPlus/GetUserSubscriptionDetailsSaga";
import watchFetchUserPrintHistoryService from "./CSAgentPortal/BrotherPlus/GetUserPrintHistorySaga";
import watchValidateUserPromoCodeService from "./brotherPlus/ValidateUserPromoCode/validateUserPromoCodeSaga";
import watchUpdateUserNotificationConsentStateService from "./brotherPlus/UserNotificationConsent/UpdateUserNotificationConsentStateSaga";
import watchGetUserNotificationConsentDetailsService from "./brotherPlus/UserNotificationConsent/GetUserNotificationConsentDetailsSaga";
import watchFetchBrotherPlusPrinters from "./brotherPlus/BrotherPlusPrinters/brotherPlusPrintersSaga";
import watchUpdateShippingAddressService from "./brotherPlus/UpdateShippingAddress/UpdateShippingAddressSaga";
import watchGetNewDevicePromoCodeService from "./brotherPlus/GetNewDevicePromoCode/getNewDevicePromoCodeSaga";


export default function* brotherPlusSagasIndex() {
    yield all([
        watchFetchCancelService(),
        watchRegisterService(),
        watchGetDevicesService(),
        watchGetDeviceStatusService(),
        watchGetPrintHistoryService(),
        watchGetUserPromoCodeService(),
        watchAddUserActivityLogService(),
        watchFetchUserDeviceStatusService(),
        watchFetchUserSubscriptionDetailsService(),
        watchFetchUserPrintHistoryService(),
        watchValidateUserPromoCodeService(),
        watchUpdateUserNotificationConsentStateService(),
        watchGetUserNotificationConsentDetailsService(),
        watchFetchBrotherPlusPrinters(),
        watchUpdateShippingAddressService(),
        watchGetNewDevicePromoCodeService()
    ])
}